import React, { useState } from 'react';
import { observer } from 'mobx-react';
import { IconSettings } from '@tabler/icons-react';
import { useStore } from 'stores/rootStore';
import Settings from 'containers/settings/Settings';
import PlayerCard from 'components/playerCard/PlayerCard';
import Modal from 'components/modal/Modal';
import styles from './GameBoard.css';

const GameBoard = observer(() => {
    const { app } = useStore();
    const [settingsVisible, setSettingsVisible] = useState(false);

    const players = app.players;
    let layout;

    switch (players.length) {
        case 2:
            layout = (
                <>
                    <div className={styles.row}>
                        <div style={{ width: '100%' }}>
                            <PlayerCard player={players[0]} rotate={180} index={0} totalPlayers={2} />
                        </div>
                    </div>
                    <div className={styles.row}>
                        <div style={{ width: '100%' }}>
                            <PlayerCard player={players[1]} index={1} totalPlayers={2} />
                        </div>
                    </div>
                </>
            );
            break;
        case 3:
            layout = (
                <>
                    <div className={styles.column}>
                        <div className={styles.column} style={{ flex: 0, height: '35%' }}>
                            <div className={styles.column}>
                                <PlayerCard player={players[0]} index={0} totalPlayers={3} />
                            </div>
                        </div>
                        <div className={styles.row} style={{ flex: 0, height: '65%' }}>
                            <PlayerCard player={players[1]} index={1} totalPlayers={3} rotate={90} />
                            <PlayerCard player={players[2]} index={2} totalPlayers={3} rotate={270} />
                        </div>
                    </div>
                </>
            );
            break;
        case 4:
            layout = (
                <div className={styles.row}>
                    <div className={styles.column}>
                        {players
                            .slice(0, 2)
                            .reverse()
                            .map((player, idx) => (
                                <PlayerCard key={player.id} player={player} index={idx} rotate={90} totalPlayers={4} />
                            ))}
                    </div>
                    <div className={styles.column}>
                        {players.slice(2, 4).map((player, idx) => (
                            <PlayerCard key={player.id} player={player} index={idx + 2} rotate={270} totalPlayers={4} />
                        ))}
                    </div>
                </div>
            );
            break;
        case 5:
            layout = (
                <div className={styles.row}>
                    <div style={{ width: '33.33%' }}>
                        <PlayerCard player={players[0]} rotate={90} index={0} totalPlayers={5} />
                    </div>
                    <div style={{ width: '66.66%' }}>
                        <div className={styles.column}>
                            <div className={styles.row}>
                                {players.slice(1, 3).map((player, idx) => (
                                    <div style={{ width: '50%' }} key={player.id}>
                                        <PlayerCard player={player} index={idx + 1} totalPlayers={5} />
                                    </div>
                                ))}
                            </div>
                            <div className={styles.row}>
                                {players.slice(3, 5).map((player, idx) => (
                                    <div style={{ width: '50%' }} key={player.id}>
                                        <PlayerCard player={player} index={idx + 3} totalPlayers={5} />
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            );
            break;
        case 6:
            layout = (
                <>
                    <div className={styles.row}>
                        {players.slice(0, 3).map((player, idx) => (
                            <div style={{ width: '33.33%' }} key={player.id}>
                                <PlayerCard player={player} rotate={180} index={idx} totalPlayers={6} />
                            </div>
                        ))}
                    </div>
                    <div className={styles.row}>
                        {players.slice(3, 6).map((player, idx) => (
                            <div style={{ width: '33.33%' }} key={player.id}>
                                <PlayerCard player={player} index={idx + 3} totalPlayers={6} />
                            </div>
                        ))}
                    </div>
                </>
            );
            break;
        default:
            layout = (
                <div className={styles.row}>
                    {players.map((player, idx) => (
                        <div style={{ flex: 1 }} key={player.id}>
                            <PlayerCard player={player} index={idx} totalPlayers={players.length} />
                        </div>
                    ))}
                </div>
            );
    }

    return (
        <div className={styles.container}>
            <div className={styles.board}>{layout}</div>

            <div className={styles.settingsButtonContainer}>
                <div className={styles.settingsButtonWrapper}>
                    <button 
                        className={styles.settingsButton}
                        onClick={() => setSettingsVisible(true)}
                    >
                        <IconSettings size={28} style={{ color: 'rgba(255,255,255,0.9)' }} />
                    </button>
                </div>
            </div>

            <Modal 
                visible={settingsVisible} 
                noCloseButton 
                onClose={() => setSettingsVisible(false)}
            >
                <Settings onSetSettings={() => setSettingsVisible(false)} />
            </Modal>
        </div>
    );
});

export default GameBoard;
